export const ROLE_IDS = {
    USER: 1,
    ADMIN: 2,
    EMPLOYEE: 3,
};

export const USER_ROLES = {
    USER: 'User',
    ADMIN: 'Administrator',
    EMPLOYEE: 'Employee',
};
